import apiClient from './api';
import { TaskInfo, TaskProgress, TaskStatistics, TaskType, GpuActiveStatistics, ApiResponse, PaginationParams, FilterParams, TaskListResponse } from '../types';

export const taskApi = {
  // 获取任务统计信息（新接口）
  getTaskStatistics: (params: { startTime: number; endTime: number; priority?: number }): Promise<ApiResponse<TaskStatistics>> =>
    apiClient.get('/monitoring/tasks/statistics', { params }),

  // 获取任务类型列表（新接口）
  getTaskTypes: (): Promise<ApiResponse<TaskType[]>> =>
    apiClient.get('/monitoring/task-types'),

  // 获取GPU活跃统计（新接口）
  getGpuActiveStatistics: (params: { startTime: number; endTime: number; priority?: number }): Promise<ApiResponse<GpuActiveStatistics>> =>
    apiClient.get('/monitoring/gpu/active-statistics', { params }),

  // 获取监控任务列表（新接口）
  getMonitoringTaskList: (params: {
    startTime: number;
    endTime: number;
    taskId?: string | null;
    status?: string;
    taskType?: number | null;
    page: number;
    size: number;
    userId?: string | null;
  }): Promise<ApiResponse<TaskListResponse>> =>
    apiClient.get('/monitoring/tasks/list', { params }),

  // 获取任务列表（保留用于其他功能）
  getTaskList: (params?: PaginationParams & FilterParams): Promise<ApiResponse<TaskInfo[]>> =>
    apiClient.get('/tasks', { params }),

  // 获取任务详情
  getTaskById: (taskId: string): Promise<ApiResponse<TaskInfo>> =>
    apiClient.get(`/tasks/${taskId}`),

  // 获取任务进度
  getTaskProgress: (taskId: string): Promise<ApiResponse<TaskProgress>> =>
    apiClient.get(`/tasks/${taskId}/progress`),

  // 获取任务结果
  getTaskResult: (taskId: string): Promise<ApiResponse<any>> =>
    apiClient.get(`/tasks/${taskId}/result`),

  // 创建任务（API Key 鉴权，Authorization: Bearer <apiKey>）
  createTask: (
    taskData: {
      taskType: number;
      userId: string;
      app: string;
      priority: number;
      payload: string;
      env?: string;
      credits?: number;
    },
    apiKey: string
  ): Promise<ApiResponse<{
    taskId: string;
    displayId: number;
    status: string;
    estimatedWaitTime: number;
  }>> =>
    apiClient.post('/tasks/create', taskData, {
      headers: { Authorization: `Bearer ${apiKey}` },
    }),

  // 更新任务状态
  updateTaskStatus: (taskId: string, statusData: {
    status: string;
    gpuId?: string;
    message?: string;
  }): Promise<ApiResponse<string>> =>
    apiClient.post(`/tasks/${taskId}/status`, statusData),

  // 更新任务结果
  updateTaskResult: (taskId: string, result: string): Promise<ApiResponse<string>> =>
    apiClient.post(`/tasks/${taskId}/result`, { result }),
};
